import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Municipality, MunicipalitySummary, UpdateMunicipality } from '../models/municipality';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MunicipalityService {
  
  private baseUrl = `${environment.apiUrl}/municipalities`;

  constructor(private http: HttpClient) {}

  getMunicipality(id: string): Observable<Municipality> {
    return this.http.get<Municipality>(`${this.baseUrl}/${id}`);
  }

  getMunicipalities(): Observable<MunicipalitySummary[]> {
    return this.http.get<Municipality[]>(`${this.baseUrl}`);
  }

  updateMunicipality(updateDto: UpdateMunicipality): Observable<void> {
      return this.http.put<void>(`${this.baseUrl}`, updateDto);
  }

  registerMunicipality(firstName: string, lastName: string, email: string, password: string, municipalityId: number): Observable<any> {
    const payload = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password,
      municipalityId: municipalityId
    };

    return this.http.post<any>(`${this.baseUrl}`, payload);
  }

}